import React from 'react';
import { FocusableParent } from 'components/navigation';
import {
  StyledModal,
  StyledModalContent,
  StyledModalNavigation,
} from 'components/Modal/NotificationModal/StyledComponents';

export const ModalLayout = ({ children }) => (
  <StyledModal as="table">
    <tbody>{children}</tbody>
  </StyledModal>
);

ModalLayout.Content = ({ children }) => (
  <StyledModalContent as="tr">
    <td>{children}</td>
  </StyledModalContent>
);

ModalLayout.Navigation = ({ children }) => (
  <StyledModalNavigation as="tr">
    <td>
      <FocusableParent
        config={{
          leaveFor: {
            right: '',
            up: '',
            left: '',
            down: '',
          },
        }}
        defaultSection
      >
        {children}
      </FocusableParent>
    </td>
  </StyledModalNavigation>
);
